<template>
    <div class="MyFollow">
      <!-- <p class="pageTop"></p> -->
      <div class="PageCommon">
        <div class="bscroll" ref="bscroll">
          <div class="bscroll-container">
        <h3 class="pageTitle" v-if="!mobileFlag">
        {{ $t("Menu_Followers_HistoricalProfit") }}
        
      </h3>
      <!-- <div class="refreshListBtnDiv">
        <el-button class="confirmDialogBtn" @click="getHistoryData" icon="el-icon-refresh-right">
          
          {{
            $t("ManualReplenishment_refresh")
          }}</el-button>
      </div> -->
            <div class="mobileFilterDiv" v-if="mobileFlag">
              <el-button class="mobileFilterBtn"  @click="openSearch()"  type="text" size="small">
                {{ $t("Common_Operation_Filter") }}
                <svg-icon class="greenIcon" icon-class="MobileFilterBtn"></svg-icon>
              </el-button>
            </div>
            
            <div class="tableSearch" v-if="!mobileFlag">

                <el-form label-position="top" :model="tableSearchForm" ref="tableSearchForm">
                  <el-form-item :label="$t('Common_TableTitle_BeginTime')" prop="settlementBeginTime">
                        <el-date-picker v-model="tableSearchForm.settlementBeginTime" 
                            value-format="yyyy-MM-dd" >
                        </el-date-picker>
                        <!-- <svg-icon class="dateIcon" icon-class="TimeIcon"></svg-icon> -->
                    </el-form-item>
                    <el-form-item :label="$t('Common_TableTitle_EndTime')" prop="settlementEndTime">
                        <el-date-picker v-model="tableSearchForm.settlementEndTime" 
                            value-format="yyyy-MM-dd" >
                        </el-date-picker>
                        <!-- <svg-icon class="dateIcon" icon-class="TimeIcon"></svg-icon> -->
                    </el-form-item>
                    <el-form-item :label="$t('Common_TableTitle_Mt4Account')" prop="followAccount">
                        <el-input v-model="tableSearchForm.followAccount"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Common_TableTitle_SignalSource')" prop="portfolioName">
                        <el-input v-model="tableSearchForm.portfolioName"></el-input>
                    </el-form-item>
                    <!-- <el-form-item :label="$t('MyFollowers_Status')" prop="type">
                      <el-select v-model="tableSearchForm.type">
                        <el-option :label="$t('MyFollowers_AllStatus')" value=""></el-option>
                        <el-option :label="$t('MyFollowers_StopCopying1')" value="1"></el-option>
                        <el-option :label="$t('MyFollowers_RejectInvitation')" value="2"></el-option>
                         <el-option :label="$t('follow_startfollow')" value="3"></el-option> -->
                        <!-- <el-option :label="$t('MyFollowers_StopCopying1')" value="3"></el-option> -->
                        <!-- <el-option label="停止跟单" value="3"></el-option> 
                      </el-select>
                    </el-form-item> -->
                    <el-form-item class="noLabel">
                        <el-button class="serchFormBtn" @click="getHistoryData(1, pageSize)">
                            {{ $t('Common_Search') }}
                            <svg-icon icon-class="SearchIcon"></svg-icon>
                        </el-button>

                    </el-form-item>
                    <el-form-item class="noLabel">

                        <el-button class="resetFormBtn" @click="reset()">
                            {{ $t('Common_Reset') }}
                            <svg-icon icon-class="ResetIcon"></svg-icon>

                        </el-button>
                    </el-form-item>

                </el-form>
            </div>
            <div class="tableDiv" v-if="!mobileFlag">
              <el-table :data="historyTableData" border style="width: 100%" >
                <el-table-column width="80" prop="sortNum" v-if="!mobileFlag" :label="$t('Common_TableTitle_Number')">
                </el-table-column>
                <el-table-column width="150" prop="settlementBeginTime"
                  :label="$t('Common_TableTitle_BeginTime')">
                </el-table-column>
                <el-table-column width="150" prop="settlementEndTime"
                  :label="$t('Common_TableTitle_EndTime')">
                </el-table-column>
                
                <el-table-column :width="mobileFlag ? '120' : 'auto'" prop="signalName"
                  :label="$t('Common_TableTitle_SignalSource')">
                </el-table-column>
                <el-table-column :width="mobileFlag ? '120' : 'auto'" prop="signalAccount"
                  :label="$t('Common_TableTitle_SignalAccount')">
                </el-table-column>
                <el-table-column :width="mobileFlag ? '120' : 'auto'" prop="followAccount" :label="$t('Common_TableTitle_Mt4Account')">
                  
                </el-table-column>
                
                <el-table-column :width="mobileFlag ? '120' : 'auto'" prop="beginPeriodEquity"
                  :label="$t('Common_TableTitle_InitialEquity')">
                </el-table-column>
                <el-table-column :width="mobileFlag ? '120' : 'auto'" prop="currentPeriodDeposit"
                  :label="$t('Common_TableTitle_CurrentPeriodDeposit')">
                </el-table-column>
                <el-table-column :width="mobileFlag ? '120' : 'auto'" prop="settlementPeriodEquity"
                  :label="$t('Common_TableTitle_SettlementEquity')">
                </el-table-column>
                <el-table-column :width="mobileFlag ? '120' : 'auto'" 
                  :label="$t('Common_TableTitle_PLSharingRatio')">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.shareProfitPercent ? scope.row.shareProfitPercent+'%' : 0}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :width="mobileFlag ? '120' : 'auto'" prop="profit"
                  :label="$t('Common_TableTitle_PaymentProfitSharingMoney')">
                </el-table-column>
                <el-table-column  prop="currentPeriodVolumes"
                :label="$t('Common_TableTitle_CurrentPeriodVolumes')">
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.currentPeriodVolumes ? scope.row.currentPeriodVolumes  : 0
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column  prop="profit"
                :label="$t('Common_TableTitle_CopyDirection')">
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.followDirection
                        ? $t("Common_TR_ReverseCopy")
                        : $t("Common_TR_Copy")
                    }}
                  </div>
                </template>
              </el-table-column>
              </el-table>
              <div class="tableTotalNum">
              {{ $t('Common_TableTotalvolumns') + ' : ' + totalVolume + ' ' + $t('Common_TableTotalprofit') + ' : ' + totalProfit + ' '}}
            </div>
              <el-pagination class="tablePage" :prev-text="$t('Common_PreviousPage')"
                :next-text="$t('Common_NexPage')" @current-change="handleHistoryCurrentChange"
                :page-sizes="[5, 10, 20, 50, 100]" @size-change="handleHistorySizeChange" :current-page="historyCurrentPage"
                :page-size="historyPageSize" layout="prev, pager, next, sizes" :pager-count="5" :total="historyTotal">
              </el-pagination>
            </div>
        <!-- <h3 class="pageTitle">
                  {{ $t('MyFollowers_Myfollowers') }}
              </h3> -->
              <div class="mobileTableList" v-show="mobileFlag">
                <div class="tableTotalTop">
                  <span>{{ $t('Common_TableTotalvolumns') }}</span>
                  <b>
                    {{ totalVolume }}
                  </b>
                </div>
                <div class="tableTotalTop">
                  <span>{{ $t('Common_TableTotalprofit') }}</span>
                  <b :class="[totalProfit > 0 ?'greenNum':'redNum']">
                    {{ totalProfit }}
                  </b> 
                </div>
                <el-collapse accordion @change="collapseChange" v-model="activeCollapse">
                    <el-collapse-item v-for="(item,index) in historyTableData" :key="index">
                    <template slot="title">
                      <div class="mobileTableCard" @click.stop="showCollapse()">
                       
                          <div class="mobileTableItem">
                          <p class="mobileTableTitle" >
                              {{ $t('Common_TableTitle_BeginTime') }}
                          </p>
                          <p class="mobileTableContent" >
                              {{ item.settlementBeginTime }}
                          </p>
                          </div>
                          <div class="mobileTableItem">
                          <p class="mobileTableTitle" >
                              {{ $t('Common_TableTitle_EndTime') }}
                          </p>
                          <p class="mobileTableContent" >
                              {{  item.settlementEndTime  }} 
                          </p>
                          </div>
                          <div class="mobileTableItem">
                          <p class="mobileTableTitle" >
                              {{ $t('Common_TableTitle_SignalSource') }}
                          </p>
                          <p class="mobileTableContent" >
                              {{  item.signalName }} 
                          </p>
                          </div>
                          <!-- <div class="mobileTableItem">
                          <p class="mobileTableTitle" >
                              {{ $t('Common_TableTitle_SignalSource') }}
                          </p>
                          <p class="mobileTableContent" >
                            {{ item.portfolioName ? item.portfolioName : 0 }}
                          </p>
                          </div> -->
                          <div class="mobileTableItem">
                            <p class="mobileTableTitle" >
                                {{ $t('Common_TableTitle_SignalAccount') }}
                            </p>
                            <p class="mobileTableContent" >
                              {{ item.signalAccount }}
                            </p>
                          </div>
                         
                      </div>
                      <div class="mobileTableBtns"  @click.stop="showCollapse()">
                        
                      </div>
                    </template>
                    <div class="mobileTableCard" >
                      <div class="mobileTableItem">
                            <p class="mobileTableTitle" >
                                {{ $t('Common_TableTitle_Mt4Account') }}
                            </p>
                            <p class="mobileTableContent" >
                              {{ item.followAccount }}
                            </p>
                          </div>
                      <div class="mobileTableItem">
                      <p class="mobileTableTitle" >
                          {{ $t('Common_TableTitle_InitialEquity') }}
                      </p>
                      <p class="mobileTableContent" >
                        <div>
                          {{ item.beginPeriodEquity }}
                        </div>
                      </p>
                      </div>
                      <div class="mobileTableItem">
                      <p class="mobileTableTitle" >
                          {{ $t('Common_TableTitle_CurrentPeriodDeposit') }}
                      </p>
                      <p class="mobileTableContent" >
                        {{  item.currentPeriodDeposit  }} 
                      </p>
                      </div>
                      <div class="mobileTableItem">
                      <p class="mobileTableTitle" >
                          {{ $t('Common_TableTitle_SettlementEquity') }}
                      </p>
                      <p class="mobileTableContent" >
                        {{  item.settlementPeriodEquity }} 
                      </p>
                      </div>
                      <div class="mobileTableItem">
                      <p class="mobileTableTitle" >
                          {{ $t('Common_TableTitle_PLSharingRatio') }}
                      </p>
                      <p  class="mobileTableContent">
                          {{  item.shareProfitPercent ? item.shareProfitPercent+'%' : 0}}
                      </p>
                      </div>
                      <div class="mobileTableItem">
                      <p class="mobileTableTitle" >
                          {{ $t('Common_TableTitle_PaymentProfitSharingMoney') }}
                      </p>
                      <p  class="mobileTableContent">
                          {{  item.profit  }} 
                      </p>
                      </div>
                      <div class="mobileTableItem">
                      <p class="mobileTableTitle" >
                          {{ $t('Common_TableTitle_CurrentPeriodVolumes') }}
                      </p>
                      <p  class="mobileTableContent">
                        {{
                          item.currentPeriodVolumes ? item.currentPeriodVolumes  : 0
                        }}
                      </p>
                      </div>
                      <div class="mobileTableItem">
                      <p class="mobileTableTitle" >
                          {{ $t('Common_TableTitle_CopyDirection') }}
                      </p>
                      <p  class="mobileTableContent">
                        {{
                      item.followDirection
                        ? $t("Common_TR_ReverseCopy")
                        : $t("Common_TR_Copy")
                    }}
                      </p>
                      </div>
                  </div>
                </el-collapse-item>
                
                </el-collapse>
                <div class="x" v-if="up && historyTableData.length < historyTotal">
                      <i  class="el-icon-loading "></i>
                      {{ $t('Common_Loading') }}
                    </div>
                    <div class="x" v-if="!up && historyTableData.length >= historyTotal">
                      
                      {{ $t('Common_NoMoreData') }}
                    </div>
            </div>
      </div>

      </div>
      </div>
      <el-drawer
              class="mobileSearchDrawer"
              :visible.sync="mobileSearchDrawer"
              direction="ttb">
              <div class="mobileFilterReturnBtnDiv">
                <el-button  class="mobileFilterReturnBtn" @click="mobileSearchDrawer = false">
                    {{ $t('Common_Search') }}
                    <i class="el-icon-arrow-up"></i>
                </el-button>
              </div>
              
              <el-form label-position="top" :model="tableSearchForm" ref="tableSearchForm">
                <el-form-item :label="$t('Common_TableTitle_BeginTime')" prop="settlementBeginTime">
                        <el-date-picker v-model="tableSearchForm.settlementBeginTime" 
                            value-format="yyyy-MM-dd" >
                        </el-date-picker>
                        <!-- <svg-icon class="dateIcon" icon-class="TimeIcon"></svg-icon> -->
                    </el-form-item>
                    <el-form-item :label="$t('Common_TableTitle_EndTime')" prop="settlementEndTime">
                        <el-date-picker v-model="tableSearchForm.settlementEndTime" 
                            value-format="yyyy-MM-dd" >
                        </el-date-picker>
                        <!-- <svg-icon class="dateIcon" icon-class="TimeIcon"></svg-icon> -->
                    </el-form-item>
                    <el-form-item :label="$t('Common_TableTitle_FollowAccount')" prop="followAccount">
                        <el-input v-model="tableSearchForm.followAccount"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Common_TableTitle_SignalSource')" prop="portfolioName">
                        <el-input v-model="tableSearchForm.portfolioName"></el-input>
                    </el-form-item>
                </el-form>
                <div class="mobileFilterBottomBtns">
                  <el-button class="resetFormBtn" @click="reset()">
                      {{ $t('Common_Reset') }}
                  </el-button>
                  <el-button class="serchFormBtn" @click="getHistoryData(1, pageSize)">
                      {{ $t('Common_Search') }}
                  </el-button>
                </div>
            </el-drawer>
    
      <div class="mobileLabelTips" ref="mobileLabelTips" v-if="isLableTips">
        <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
        <p>
          {{ labelTitle }}
        </p>
        <div>
          {{ labelTxt }}
        </div>
      </div>
      <!-- <load2 /> -->
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import { concatParams, concatTableData, dateGmt8 } from "../../plugins/common.js";
  import { mapState } from "vuex";
  import PopupTips from '@/components/moudule/PopupTips.vue'
  import load2 from '@/components/moudule/Loading.vue'
  import BScroll from '@better-scroll/core'
  import Pullup from '@better-scroll/pull-up'
  import { formatNumberFractionDigits } from "@/shared/utils/formatNumber.js";
  
  BScroll.use(Pullup)
  
  
  export default {
    name: "FollowHistory",
    components: {
      PopupTips,
      load2
    },
    computed: {
      ...mapState(["checkPortfolio", "userInfo", "token", 'mobileFlag']),
    },
    data() {
      return {
        tableData: [],
        currentPage: 1,
        total: 0,
        pageSize: 5,
        historyCurrentPage: 1,
        historyTotal: 0,
        historyPageSize: 5,
        checkInviteDrawer: false,
        fullscreenLoading: true,
        checkRow: {},
        isRefuse: false,
        isFollowing: false,
        followDrawerTitle: "",
        activeName: "follow",
        historyTableData: [],
        labelTitle: '',
        labelTxt: '',
        isLableTips: false,
        accountList: [],
        isPopupVisible: false,
        iconImg:require('../../assets/images/NotifyWarning.svg'),
        tableSearchForm: {
              followAccount: '',
                portfolioName : '',
                settlementEndTime:'',
                settlementBeginTime:''
        },
        totalProfit:0,
        totalVolume:0,
        mobileSearchDrawer:true,
	          up:false,
            activeCollapse:0,
      };
    },
    created() {
      this.getHistoryData(1,5);
    },
    methods: {
      formatNumberFractionDigits,
      collapseChange(){
      this.$nextTick(() => {
            
            if(!this.firstOpen){
              this.scroll.maxScrollY = this.scroll.maxScrollY - 150
              this.firstOpen = true
            }else{
              this.scroll.maxScrollY = this.scroll.maxScrollY + 150
              this.firstOpen = false
            }
      });
    },
      openSearch(){
        this.mobileSearchDrawer = true
      },
      scrollFn(){
        this.$nextTick(() => {
         
            if (!this.scroll) {
                this.scroll = new BScroll(this.$refs.bscroll, {
                    click: true,
                    scrollY: true,
                    probeType: 3
                });
            }else{
                this.scroll.refresh();
            }
            
            //touchEnd（手指离开以后触发） 通过这个方法来监听下拉刷新
            this.scroll.on('touchEnd', (pos) => {
                //上拉加载 总高度>下拉的高度+10 触发加载更多
                if(this.scroll.maxScrollY>pos.y + 50){
                    // console.log("加载更多")
                    this.up=true;
                    setTimeout(()=>{
                    //使用refresh 方法 来更新scroll  解决无法滚动的问题
                        if(this.historyTableData.length < this.historyTotal){
                          this.currentPage = this.currentPage + 1
                          this.getHistoryData(this.currentPage,this.pageSize,'noRefresh')
                          this.scroll.refresh();
                          this.up=false;
                        }else{
                          this.up=false
                        }
                        
                   },1000) 
                   
                }
                // console.log(this.scroll.maxScrollY+"总距离----下拉的距离"+pos.y)
            })
          
            // console.log(this.scroll.maxScrollY)
        });
    },
      getHistoryData(pageIndex,pageSize,tag) {
        this.mobileSearchDrawer = false
         if (tag == "search") {
         this.currentPage = 1;
        }
        if(!this.mobileFlag || tag !== 'noRefresh'){
          this.tableData = [];

        }
        var params = {
          portfolioName: this.tableSearchForm.portfolioName.trim(),
          followAccount: this.tableSearchForm.followAccount?this.tableSearchForm.followAccount.trim():undefined,
          settleBeginTime: this.tableSearchForm.settlementBeginTime,
          settleEndTime: this.tableSearchForm.settlementEndTime,
          type:2,
          portfolioId: 0,
          pageIndex: pageIndex,
          pageSize: pageSize,
        };
           params.status = this.tableSearchForm.status;
      const loading = this.$loading({
            lock: true,
          });
        this.$axios
          .post("/Api/Invite/History" ,params)
          .then((res) => {
            let dt = res.data;
  
            if (dt.isSuccess) {
              // dt.result.pageList.forEach((item,index) =>{
              //     item.beginTime = dateGmt8(item.beginTime)
              //     item.endTime = dateGmt8(item.endTime)

              // })
              this.historyTotal = dt.result.total;
              this.totalProfit = dt.result.totalProfit;
              this.totalVolume = dt.result.totalVolume;
              if(this.mobileFlag && tag == 'noRefresh'){
                dt.result.pageList.forEach((item) =>{
                  this.historyTableData.push(item)
                })
                
                
              }else{
                this.historyTableData = concatTableData(
                    dt.result.pageList,
                    dt.result.total,
                    this.historyCurrentPage,
                    this.historyPageSize
                  );
              }
              if(this.mobileFlag){
                this.scrollFn()
              }
            }
          }).finally(()=>{
            // this.$refs.tableSearchForm.resetFields();
           this.fullscreenLoading = false;
           loading.close();
          })
      },
      handleHistoryCurrentChange(val) {
        this.historyCurrentPage = val;
        this.getHistoryData(this.historyCurrentPage, this.historyPageSize);
      },
      handleHistorySizeChange(val) {
        this.historyPageSize = val;
        this.getHistoryData(this.historyCurrentPage, this.historyPageSize);
      },
      reset() {
        this.$refs.tableSearchForm.resetFields();
        this.mobileSearchDrawer = false;
        this.currentPage = 1;
        this.getHistoryData(1,this.pageSize);
      },
    },
  };
  </script>
  <style lang="less" scoped>
  .refreshListBtnDiv{
  position: absolute;
  right: 60px;
  top: 40px;
}
@media screen and (max-width:767px){
  .refreshListBtnDiv{
      position: absolute;
      right: 20px;
      top: 5px;
      .confirmDialogBtn{
        padding: 10px ;
        font-size: 12px;
        line-height: 15px;
      }
  }
}
  </style>
  